import { appendSvgCurveBottom } from "../../utils/appendSvgCurve";

function getLi(scene) {
  // prevent rebuilding text blocks if already created
  if (scene.querySelector(".scene-5__text")) return;

  const listItems = scene.querySelectorAll(".content_text ul li");
  if (!listItems.length) return;

  const overflow = scene.querySelector(".article_block_item__overflow");
  if (!overflow) return;

  listItems.forEach((li, index) => {
    const div = document.createElement("div");
    div.className = `scene-5__text scene-5__text--${index + 1}`;
    div.innerHTML = li.innerHTML;
    overflow.appendChild(div);
  });

  scene.querySelector(".content_text ul")?.remove();
}

// requestIdle fallback
// const idle = (cb) => ("requestIdleCallback" in window ? requestIdleCallback(cb, { timeout: 120 }) : setTimeout(cb, 0));

// function preloadFrames(count, pathFn, eager) {
//   const frames = new Array(count);
//   const e = Math.min(eager, count);
//   for (let i = 0; i < e; i++) {
//     const im = new Image();
//     im.decoding = "async";
//     im.fetchPriority = "low";
//     im.src = pathFn(i);
//     frames[i] = im;
//   }
//   idle(() => {
//     for (let i = e; i < count; i++) {
//       if (!frames[i]) {
//         const im = new Image();
//         im.decoding = "async";
//         im.fetchPriority = "low";
//         im.src = pathFn(i);
//         frames[i] = im;
//       }
//     }
//   });
//   return frames;
// }

//
//
//
//
// CHANGED FOR ANDROID, WORKING CODE ABOVE
//
//
//
//

function preloadFrames(count, pathFn) {
  const frames = new Array(count);

  for (let i = 0; i < count; i++) {
    const img = new Image();
    img.src = pathFn(i); // no async flags, no tricks
    frames[i] = img;
  }

  return frames;
}

export function scene_5_animated() {
  const isAndroid = /Android/i.test(navigator.userAgent);

  const isTouch = ScrollTrigger.isTouch === 1 || matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 0;
  const isLandscapePhone = window.matchMedia("(orientation: landscape) and (max-height: 500px)").matches;

  const isIpad = /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isIPhone = /iPhone/.test(navigator.userAgent);
  console.log(isIPhone, "isIPhone");
  if (isIpad) {
    document.body.classList.add("is-ipad");
  }

  if (isIPhone) {
    document.body.classList.add("is-iphone");
  }

  const scene = document.querySelector(".scene-5");
  if (!scene) return;

  // avoid double-binding
  if (scene.dataset.bound === "1") return;
  scene.dataset.bound = "1";
  if (isIpad) {
  } else if (!isAndroid && !isIPhone) {
    console.log("!isIPhone");
    getLi(scene);

    appendSvgCurveBottom(".scene-5");
  }

  const imgEl = scene.querySelector("img");
  const lis = Array.from(scene.querySelectorAll(".scene-5__text") || []);
  // if (!imgEl || !lis.length) return;

  // ---------------------------------------------
  // Image sequence
  // ---------------------------------------------
  const imageCount = 60;
  const START_INDEX = 20;
  const path = (i) => `/uploads/images/3d/jr-angle/${String(i).padStart(2, "0")}.webp`;
  const wrap = gsap.utils.wrap(0, imageCount);

  const frames = preloadFrames(imageCount, path, isTouch ? 20 : 12);

  let currentIndex = START_INDEX;
  let targetIndex = START_INDEX;
  imgEl.src = frames[START_INDEX]?.src || path(START_INDEX);

  (function loop() {
    if (currentIndex !== targetIndex) {
      currentIndex = targetIndex;
      const im = frames[currentIndex];
      imgEl.src = im && im.complete ? im.src : path(currentIndex);
    }
    requestAnimationFrame(loop);
  })();

  const INTRO_TURNS = 0.25; // pre-pin
  const PIN_TURNS = 1.0; // while pinned
  let introTurns = 0,
    pinTurns = 0;

  const updateTarget = () => {
    const totalTurns = introTurns + pinTurns;
    targetIndex = wrap(START_INDEX + Math.floor(totalTurns * imageCount));
  };

  ScrollTrigger.create({
    trigger: scene,
    start: "top bottom",
    end: "top top",
    scrub: true,
    onUpdate: (st) => {
      introTurns = st.progress * INTRO_TURNS;
      updateTarget();
    },
    invalidateOnRefresh: true,
  });

  // ---------------------------------------------
  // Text reveal – mobile vs desktop
  // ---------------------------------------------
  gsap.set(lis, {
    opacity: 0,
    y: 12,
    willChange: "transform,opacity",
    transform: "translate3d(0,0,0)",
  });
  $(".scene-5").closest(".pin-spacer").addClass("pin-spacer--light");

  //
  //
  //
  //
  //

  function createScene5StepsAndroid() {
    const scene = document.querySelector(".scene-5");
    if (!scene || scene.dataset.androidBuilt === "1") return;

    scene.dataset.androidBuilt = "1";
    const list = scene.querySelector(".content_text ul");
    if (!list) return;

    const parent = scene.parentElement; // .article_block_items
    const items = [...list.querySelectorAll("li")];

    // Create FIXED text container
    const fixedText = document.createElement("div");
    fixedText.className = "scene-5__fixed-text";

    items.forEach((li, i, tot) => {
      if (i === 0) {
        const divEpmty = document.createElement("div");
        divEpmty.className = "scene-5__fixed-text-item scene-5__fixed-text-item--empty";

        const divEpmt2 = document.createElement("div");
        divEpmt2.className = "scene-5__fixed-text-item scene-5__fixed-text-item--empty";

        const divEpmty3 = document.createElement("div");
        divEpmty3.className = "scene-5__fixed-text-item scene-5__fixed-text-item--empty";

        fixedText.appendChild(divEpmty);
        fixedText.appendChild(divEpmt2);
        fixedText.appendChild(divEpmty3);
      }

      const div = document.createElement("div");
      div.className = `scene-5__fixed-text-item scene-5__fixed-text-item--${i + 1}`;

      div.innerHTML = li.innerHTML;
      if (i === 0) div.classList.add("is-active");
      fixedText.appendChild(div);

      const divEpmty = document.createElement("div");
      divEpmty.className = "scene-5__fixed-text-item";
      fixedText.appendChild(divEpmty);

      if (i === tot.length - 1) {
        const divEpmty = document.createElement("div");
        divEpmty.className = "scene-5__fixed-text-item scene-5__fixed-text-item--empty";

        const divEpmt2 = document.createElement("div");
        divEpmt2.className = "scene-5__fixed-text-item scene-5__fixed-text-item--empty";

        fixedText.appendChild(divEpmty);
        fixedText.appendChild(divEpmt2);
      }
    });

    document.body.appendChild(fixedText);

    // Remove original list
    list.remove();

    // Create scroll step markers
    const frag = document.createDocumentFragment();
    for (let i = 0; i <= items.length; i++) {
      const step = document.createElement("div");
      step.className = "scene5-step";
      step.dataset.step = i;
      frag.appendChild(step);

      if (i === 0) {
        const step2 = document.createElement("div");
        step2.className = "scene5-step";
        step2.dataset.step = i;
        frag.appendChild(step2);

        const step3 = document.createElement("div");
        step3.className = "scene5-step";
        step3.dataset.step = i;
        frag.appendChild(step3);
      }

      if (i === items.length - 1) {
        const step2 = document.createElement("div");
        step2.className = "scene5-step";
        step2.dataset.step = i;
        frag.appendChild(step2);

        const step3 = document.createElement("div");
        step3.className = "scene5-step";
        step3.dataset.step = i;
        frag.appendChild(step3);
      }
    }

    for (let i = 0; i <= items.length; i++) {
      const step = document.createElement("div");
      step.className = "scene5-step";
      step.dataset.step = i;
      frag.appendChild(step);
    }

    parent.appendChild(frag);

    const stepSpacer = document.createElement("div");
    stepSpacer.className = "scene5-step__spacer";
    parent.appendChild(stepSpacer);

    appendSvgCurveBottom(".scene-5", true);

    setTimeout(() => {
      document.querySelector(".scene-5__fixed-text").style.display = "block";
    }, 300);
  }

  function scene5Android(isIpad) {
    createScene5StepsAndroid();

    const texts = [...document.querySelectorAll(".scene-5__fixed-text-item")];
    const steps = [...document.querySelectorAll(".scene5-step")];
    const scene = document.querySelector(".scene-5");
    const srcImg = scene.querySelector(".article_block_item_img img");

    // create FIXED bottle overlay
    const fixedImg = document.createElement("img");
    fixedImg.className = "scene-5__fixed-img";
    fixedImg.src = srcImg.src;
    document.body.appendChild(fixedImg);

    // image sequence
    const imageCount = 60;
    const START_INDEX = 20;
    const path = (i) => `/uploads/images/3d/jr-angle/${String(i).padStart(2, "0")}.webp`;

    const frames = new Array(imageCount);
    for (let i = 0; i < imageCount; i++) {
      const im = new Image();
      im.src = path(i);
      frames[i] = im;
    }

    let currentIndex = START_INDEX;
    let targetIndex = START_INDEX;

    function rafLoop() {
      if (currentIndex !== targetIndex) {
        currentIndex = targetIndex;
        fixedImg.src = frames[currentIndex].src;
      }
      requestAnimationFrame(rafLoop);
    }
    requestAnimationFrame(rafLoop);

    function setActiveText(idx) {
      texts.forEach((t, i) => t.classList.toggle("is-active", i === idx));
    }

    let lastStep = -1;

    function onScroll() {
      const appearLine = window.innerHeight * 0.4; // when bottle becomes visible
      const activeLine = window.innerHeight * 0.4; // when step becomes active

      let stepIndex = -1;
      let firstStepRect = steps[0].getBoundingClientRect();
      let lastStepRect = steps[steps.length - 1].getBoundingClientRect();

      // -------------------------------------------
      // 1) Bottle appears when first step reaches appearLine
      // -------------------------------------------
      if (firstStepRect.top <= appearLine) {
        fixedImg.style.opacity = "1";
      } else {
        // too early → hide everything
        fixedImg.style.opacity = "0";
        texts.forEach((t) => t.classList.remove("is-active"));
        lastStep = -1;
        return;
      }

      // -------------------------------------------
      // 2) Check if we finished (passed last step)
      // -------------------------------------------
      // last step is ABOVE activeLine → animation finished
      if (lastStepRect.bottom < activeLine) {
        fixedImg.style.opacity = "0"; // hide bottle
        texts.forEach((t) => t.classList.remove("is-active")); // hide text
        lastStep = -1; // reset so scrolling up works
        return;
      }

      // -------------------------------------------
      // 3) Determine which step is active
      // -------------------------------------------
      for (let i = 0; i < steps.length; i++) {
        const r = steps[i].getBoundingClientRect();
        if (r.top <= activeLine && r.bottom >= activeLine) {
          stepIndex = i;
          break;
        }
      }

      // no active step yet → hide text but keep bottle (because appearLine was reached)
      if (stepIndex === -1) {
        texts.forEach((t) => t.classList.remove("is-active"));
        lastStep = -1;
        return;
      }

      // -------------------------------------------
      // 4) Trigger new step (text + frame)
      // -------------------------------------------
      if (stepIndex !== lastStep) {
        lastStep = stepIndex;

        const textIdx = stepIndex >= texts.length ? texts.length - 1 : stepIndex;
        setActiveText(textIdx);
      }

      // -------------------------------------------
      // 5) Smooth frame progression (like before)
      // -------------------------------------------
      const activeStepRect = steps[stepIndex].getBoundingClientRect();

      // where is the activeLine inside this step (0 = top, 1 = bottom)
      const localProgressRaw = (activeLine - activeStepRect.top) / Math.max(1, activeStepRect.height);
      const localProgress = Math.min(Math.max(localProgressRaw, 0), 1);

      // global progress 0..1 across the whole step region
      const totalSteps = Math.max(1, steps.length - 1);
      const globalProgress = (stepIndex + localProgress) / totalSteps;

      // --- rotation (looping, both directions) ---
      const imageCount = 60;
      const START_INDEX = 20;
      const TURNS = 2; // how many full spins over the entire sequence

      const mod1 = (n) => ((n % 1) + 1) % 1;

      const rotationProgress = globalProgress * TURNS;
      const wrapped = mod1(rotationProgress); // 0..1
      const frameOffset = Math.round(wrapped * (imageCount - 1));

      let index = (START_INDEX + frameOffset) % imageCount;
      if (index < 0) index += imageCount;

      targetIndex = index;

      // -------------------------------------------
      // 6) Fake pinning phases for the bottle
      // -------------------------------------------
      // phases in terms of globalProgress (0..1)
      const PIN_IN_START = 0.05; // start fading in fixed bottle
      const PIN_IN_END = 0.15; // fully pinned
      const PIN_OUT_START = 0.85; // start “unpin” (scroll away)
      const PIN_OUT_END = 0.98; // fully gone

      let bottleOpacity = 0;
      let bottleShift = 0; // in vh, for scroll-away effect

      if (isIpad) {
        if (globalProgress < PIN_OUT_START) {
          bottleOpacity = 1;
          bottleShift = 0;
        } else if (globalProgress < PIN_OUT_END) {
          const phase = (globalProgress - PIN_OUT_START) / (PIN_OUT_END - PIN_OUT_START);
          const t = Math.max(0, Math.min(1, phase)); // clamp
          bottleOpacity = 1; // stays fully visible
          bottleShift = -30 * t; // smooth move
        } else {
          bottleOpacity = 0;
          bottleShift = -30;
        }
      } else {
        if (globalProgress < PIN_IN_START) {
          // before pin region: bottle basically not visible (fixed)
          bottleOpacity = 0;
        } else if (globalProgress < PIN_IN_END) {
          // fade in fixed bottle
          const t = (globalProgress - PIN_IN_START) / (PIN_IN_END - PIN_IN_START);
          bottleOpacity = t;
        } else if (globalProgress < PIN_OUT_START) {
          // fully pinned
          bottleOpacity = 1;
        } else if (globalProgress < PIN_OUT_END) {
          // fade out & move up to fake "scroll away"
          const t = (globalProgress - PIN_OUT_START) / (PIN_OUT_END - PIN_OUT_START);
          bottleOpacity = 1 - t;
          bottleShift = -30 * t; // move up by up to -30vh
        } else {
          // completely gone
          bottleOpacity = 0;
          bottleShift = -30;
        }
      }

      // apply styles to fixed bottle
      fixedImg.style.opacity = bottleOpacity.toString();
      fixedImg.style.transform = `translate(-50%, calc(-50% + ${bottleShift}vh))`;
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  if (isAndroid || isIpad || isIPhone) {
    scene5Android(isIpad);
    return;
  }
  // 1) Tiny landscape phones (no pin)
  if (isTouch && isLandscapePhone) {
    const PX_PER_SEGMENT = 120;
    const EXTRA_SCROLL = 200;
    const totalScroll = lis.length * PX_PER_SEGMENT + EXTRA_SCROLL;

    const thresholds = lis.map((_, i) => (i * PX_PER_SEGMENT) / totalScroll);
    let activeIndex = -1;

    function setActive(index, direction) {
      if (index < 0 || index >= lis.length) return;
      const currentLi = lis[index];

      if (activeIndex !== -1 && activeIndex !== index) {
        const prevLi = lis[activeIndex];
        const yOut = direction > 0 ? -6 : 6;
        gsap.to(prevLi, {
          opacity: 0,
          y: yOut,
          duration: 0.3,
          ease: "power1.in",
        });
      }

      gsap.to(currentLi, {
        opacity: 1,
        y: 0,
        duration: 0.35,
        ease: "power1.out",
      });

      activeIndex = index;
    }

    ScrollTrigger.create({
      trigger: scene,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (st) => {
        const p = st.progress;
        let idx = 0;
        for (let i = 0; i < thresholds.length; i++) {
          if (p >= thresholds[i]) idx = i;
        }
        if (idx !== activeIndex) {
          const direction = idx > activeIndex ? 1 : -1;
          setActive(idx, direction);
        }
      },
    });

    ScrollTrigger.create({
      trigger: scene,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      onUpdate: (st) => {
        pinTurns = st.progress * PIN_TURNS;
        updateTarget();
      },
      invalidateOnRefresh: true,
    });

    return;
  }

  // 2) Other touch devices (phones) – pinned, step-through
  if (isTouch) {
    const PX_PER_SEGMENT = 420;
    const ITEM_SEGMENTS = 2;
    const EXTRA_SCROLL = 300;

    const totalSteps = lis.length * ITEM_SEGMENTS - 1;
    const totalScroll = totalSteps * PX_PER_SEGMENT + EXTRA_SCROLL;
    const endValue = `+=${totalScroll}`; // 👈 shared string

    const pinSettings = {
      trigger: scene,
      start: "top top",
      end: endValue,
      pin: true,
      scrub: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      scroller: window, // 👈 makes sure smoother defaults don’t leak
      // pinType: "fixed", // 👈 IMPORTANT for Android
      // pinType: isAndroid ? "fixed" : undefined,
      pinType: isAndroid || isIOS ? "fixed" : undefined,
    };

    ScrollTrigger.create(pinSettings);

    ScrollTrigger.create({
      trigger: scene,
      start: "top top",
      end: endValue, // 👈 same distance
      scrub: true,
      onUpdate: (st) => {
        pinTurns = st.progress * PIN_TURNS;
        updateTarget();
      },
      invalidateOnRefresh: true,
    });

    gsap.set(lis, { opacity: 0, y: 12 });

    let activeIndex = -1;

    ScrollTrigger.create({
      trigger: scene,
      start: "top top",
      end: endValue, // 👈 same again
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (st) => {
        const p = st.progress;
        const distance = p * totalScroll;

        let step = Math.floor(distance / PX_PER_SEGMENT);
        if (step < 0) step = 0;
        if (step > totalSteps) step = totalSteps;

        let newIndex = -1;
        if (step % 2 === 0) newIndex = step / 2;
        else newIndex = -1;

        if (newIndex === activeIndex) return;

        const prevIndex = activeIndex;
        activeIndex = newIndex;

        if (prevIndex !== -1 && lis[prevIndex]) {
          gsap.to(lis[prevIndex], {
            opacity: 0,
            y: -6,
            duration: 0.25,
            ease: "power1.in",
          });
        }

        if (activeIndex !== -1 && lis[activeIndex]) {
          gsap.to(lis[activeIndex], {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: "power1.out",
          });
        }
      },
    });

    return;
  }

  // 3) Desktop – pinned timeline (original behaviour)
  const SEG = 1;
  const PX_PER_SEGMENT = 500;
  const totalDesktopScroll = lis.length * PX_PER_SEGMENT;
  const endDesktop = `+=${totalDesktopScroll}`; // 👈 one canonical value

  const tl = gsap.timeline({
    defaults: { ease: "none" },
    scrollTrigger: {
      trigger: scene,
      start: "top top",
      end: endDesktop, // 👈 no function
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onRefresh: () => {
        gsap.set(lis, { opacity: 0, y: 12 });
      },
    },
  });

  ScrollTrigger.create({
    trigger: scene,
    start: "top top",
    end: endDesktop, // 👈 no tl.scrollTrigger.end
    scrub: true,
    onUpdate: (st) => {
      pinTurns = st.progress * PIN_TURNS;
      updateTarget();
    },
    invalidateOnRefresh: true,
  });

  const TEXT_IN = 0.35;
  const HOLD = 0.15;
  const TEXT_OUT = 0.35;
  const GAP = 0.15;

  lis.forEach((li, i) => {
    const base = i * SEG;
    tl.to(li, { opacity: 1, y: 0, duration: SEG * TEXT_IN }, base);
    tl.to({}, { duration: SEG * HOLD }, base + SEG * TEXT_IN);
    tl.to(li, { opacity: 0, y: -6, duration: SEG * TEXT_OUT }, base + SEG * (TEXT_IN + HOLD));
    tl.to({}, { duration: SEG * GAP }, base + SEG * (TEXT_IN + HOLD + TEXT_OUT));
  });
}
// ============================ CHANGED FOR MATCH MEDIA END . WORKING CODE BELOW BEFORE CHANGE

// import { deviceIsDesktop } from "../common/checkDevice";
// import { appendSvgCurveBottom } from "../../utils/appendSvgCurve";

// function getLi() {
//   const listItems = document.querySelectorAll(".scene-5 .content_text ul li");
//   listItems.forEach((li, index) => {
//     const div = document.createElement("div");
//     div.className = `scene-5__text scene-5__text--${index + 1}`;
//     div.innerHTML = li.innerHTML;
//     document.querySelector(".scene-5 .article_block_item__overflow").appendChild(div);
//   });
//   document.querySelector(".scene-5 .content_text ul")?.remove();
// }

// // requestIdle fallback
// const idle = (cb) => ("requestIdleCallback" in window ? requestIdleCallback(cb, { timeout: 120 }) : setTimeout(cb, 0));

// function preloadFrames(count, pathFn, eager) {
//   const frames = new Array(count);
//   const e = Math.min(eager, count);
//   for (let i = 0; i < e; i++) {
//     const im = new Image();
//     im.decoding = "async";
//     im.fetchPriority = "low";
//     im.src = pathFn(i);
//     frames[i] = im;
//   }
//   idle(() => {
//     for (let i = e; i < count; i++) {
//       if (!frames[i]) {
//         const im = new Image();
//         im.decoding = "async";
//         im.fetchPriority = "low";
//         im.src = pathFn(i);
//         frames[i] = im;
//       }
//     }
//   });
//   return frames;
// }

// export function scene_5_animated() {
//   getLi();
//   appendSvgCurveBottom(".scene-5");

//   const scene = document.querySelector(".scene-5");
//   const imgEl = scene?.querySelector("img");
//   const lis = Array.from(scene?.querySelectorAll(".scene-5__text") || []);
//   if (!scene || !imgEl || !lis.length) return;

//   const isDesktop = deviceIsDesktop();
//   const isTouch = ScrollTrigger.isTouch === 1;
//   const isLandscapePhone = window.matchMedia("(orientation: landscape) and (max-height: 500px)").matches;

//   // ---------------------------------------------
//   // Image sequence (keep super light & steady)
//   // ---------------------------------------------
//   const imageCount = 60;
//   const START_INDEX = 20;
//   const path = (i) => `/uploads/images/3d/jr-angle/${String(i).padStart(2, "0")}.webp`;
//   const wrap = gsap.utils.wrap(0, imageCount);

//   // a bit more eager on mobile to reduce first-touch stutter
//   const frames = preloadFrames(imageCount, path, isTouch ? 20 : 12);

//   let currentIndex = START_INDEX;
//   let targetIndex = START_INDEX;
//   imgEl.src = frames[START_INDEX]?.src || path(START_INDEX);

//   // rAF swap only when index changes
//   (function loop() {
//     if (currentIndex !== targetIndex) {
//       currentIndex = targetIndex;
//       const im = frames[currentIndex];
//       imgEl.src = im && im.complete ? im.src : path(currentIndex);
//     }
//     requestAnimationFrame(loop);
//   })();

//   // Start rotating as soon as scene enters; keep rotating during pin
//   const INTRO_TURNS = 0.25; // pre-pin
//   const PIN_TURNS = 1.0; // while pinned
//   let introTurns = 0,
//     pinTurns = 0;

//   const updateTarget = () => {
//     const totalTurns = introTurns + pinTurns;
//     targetIndex = wrap(START_INDEX + Math.floor(totalTurns * imageCount));
//   };

//   ScrollTrigger.create({
//     trigger: scene,
//     start: "top bottom",
//     end: "top top",
//     scrub: true,
//     onUpdate: (st) => {
//       introTurns = st.progress * INTRO_TURNS;
//       updateTarget();
//     },
//     invalidateOnRefresh: true,
//   });

//   // ---------------------------------------------
//   // Text reveal – mobile: reveal-once (no scrub),
//   // desktop: scrubbed but linear & minimal.
//   // ---------------------------------------------

//   // common initial styles
//   gsap.set(lis, { opacity: 0, y: 12, willChange: "transform,opacity", transform: "translate3d(0,0,0)" });
//   $(".scene-5").closest(".pin-spacer").addClass("pin-spacer--light");

//   if (isTouch && isLandscapePhone) {
//     const PX_PER_SEGMENT = 120;
//     const EXTRA_SCROLL = 200;
//     const totalScroll = lis.length * PX_PER_SEGMENT + EXTRA_SCROLL;

//     const thresholds = lis.map((_, i) => (i * PX_PER_SEGMENT) / totalScroll);

//     let activeIndex = -1; // which text is currently "on"

//     function setActive(index, direction) {
//       if (index < 0 || index >= lis.length) return;

//       const currentLi = lis[index];

//       // fade out previous one (if any)
//       if (activeIndex !== -1 && activeIndex !== index) {
//         const prevLi = lis[activeIndex];
//         // move slightly up or down depending on scroll direction
//         const yOut = direction > 0 ? -6 : 6;

//         gsap.to(prevLi, {
//           opacity: 0,
//           y: yOut,
//           duration: 0.3,
//           ease: "power1.in",
//         });
//       }

//       // fade in the new one
//       gsap.to(currentLi, {
//         opacity: 1,
//         y: 0,
//         duration: 0.35,
//         ease: "power1.out",
//       });

//       activeIndex = index;
//     }

//     // text reveal based on scroll through the scene; no pin
//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top bottom",
//       end: "bottom top",
//       scrub: true,
//       invalidateOnRefresh: true,
//       onUpdate: (st) => {
//         const p = st.progress; // 0..1

//         // figure out which index fits current progress
//         let idx = 0;
//         for (let i = 0; i < thresholds.length; i++) {
//           if (p >= thresholds[i]) idx = i;
//         }

//         if (idx !== activeIndex) {
//           const direction = idx > activeIndex ? 1 : -1; // scroll down / up
//           setActive(idx, direction);
//         }
//       },
//     });

//     // keep bottle rotating while scene is in view (no pin) – unchanged
//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top bottom",
//       end: "bottom top",
//       scrub: true,
//       onUpdate: (st) => {
//         pinTurns = st.progress * PIN_TURNS;
//         updateTarget();
//       },
//       invalidateOnRefresh: true,
//     });

//     return; // ✅ we’re done for landscape touch
//   }
//   if (isTouch) {
//     // ------- MOBILE / iPhone: no scrub for text -------
//     const PX_PER_SEGMENT = 420; // scroll distance per "step"
//     const ITEM_SEGMENTS = 2; // text + dark gap (except last)
//     const EXTRA_SCROLL = 300;

//     // total steps = (items * 2 - 1)
//     // example: 4 items => steps: 0(text0),1(dark),2(text1),3(dark),4(text2),5(dark),6(text3)
//     const totalSteps = lis.length * ITEM_SEGMENTS - 1;

//     const totalScroll = totalSteps * PX_PER_SEGMENT + EXTRA_SCROLL;

//     const pinST = ScrollTrigger.create({
//       trigger: scene,
//       start: "top top",
//       end: `+=${totalScroll}`,
//       pin: true,
//       scrub: true,
//       anticipatePin: 1,
//       invalidateOnRefresh: true,
//     });

//     // bottle rotation stays unchanged
//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top top",
//       end: () => pinST.end,
//       scrub: true,
//       onUpdate: (st) => {
//         pinTurns = st.progress * PIN_TURNS;
//         updateTarget();
//       },
//       invalidateOnRefresh: true,
//     });

//     // hide all texts initially
//     gsap.set(lis, { opacity: 0, y: 12 });

//     let activeIndex = -1; // -1 = darkness

//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top top",
//       end: () => pinST.end,
//       scrub: true,
//       invalidateOnRefresh: true,
//       onUpdate: (st) => {
//         const p = st.progress;
//         const distance = p * totalScroll;

//         // which step are we on?
//         let step = Math.floor(distance / PX_PER_SEGMENT);
//         if (step < 0) step = 0;
//         if (step > totalSteps) step = totalSteps;

//         // determine new index:
//         // even steps → text index, odd steps → darkness
//         let newIndex = -1;
//         if (step % 2 === 0) {
//           newIndex = step / 2; // 0,1,2,...
//         } else {
//           newIndex = -1; // darkness
//         }

//         // no change → skip work
//         if (newIndex === activeIndex) return;

//         const prevIndex = activeIndex;
//         activeIndex = newIndex;

//         // fade out previous text
//         if (prevIndex !== -1 && lis[prevIndex]) {
//           gsap.to(lis[prevIndex], {
//             opacity: 0,
//             y: -6,
//             duration: 0.25,
//             ease: "power1.in",
//           });
//         }

//         // fade in new text
//         if (activeIndex !== -1 && lis[activeIndex]) {
//           gsap.to(lis[activeIndex], {
//             opacity: 1,
//             y: 0,
//             duration: 0.3,
//             ease: "power1.out",
//           });
//         }
//         // if activeIndex === -1 → darkness
//       },
//     });
//   } else {
//     // ------- DESKTOP: scrubbed, but linear & simple -------
//     const SEG = 1;
//     const PX_PER_SEGMENT = 500;

//     const tl = gsap.timeline({
//       defaults: { ease: "none" }, // critical: no ease on scroll-scrub
//       scrollTrigger: {
//         trigger: scene,
//         start: "top top",
//         end: () => `+=${lis.length * PX_PER_SEGMENT}`,
//         scrub: true,
//         pin: true,
//         anticipatePin: 1,
//         invalidateOnRefresh: true,
//       },
//     });

//     // continue bottle rotation during pin
//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top top",
//       end: () => tl.scrollTrigger.end, // same absolute end
//       scrub: true,
//       onUpdate: (st) => {
//         pinTurns = st.progress * PIN_TURNS;
//         updateTarget();
//       },
//       invalidateOnRefresh: true,
//     });

//     const TEXT_IN = 0.35;
//     const HOLD = 0.15;
//     const TEXT_OUT = 0.35;
//     const GAP = 0.15;

//     lis.forEach((li, i) => {
//       const base = i * SEG;
//       // IN
//       tl.to(li, { opacity: 1, y: 0, duration: SEG * TEXT_IN }, base);
//       // HOLD
//       tl.to({}, { duration: SEG * HOLD }, base + SEG * TEXT_IN);
//       // OUT
//       tl.to(li, { opacity: 0, y: -6, duration: SEG * TEXT_OUT }, base + SEG * (TEXT_IN + HOLD));
//       // GAP
//       tl.to({}, { duration: SEG * GAP }, base + SEG * (TEXT_IN + HOLD + TEXT_OUT));
//     });
//   }
// }
